// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCardStyles } from "@awc/Overrides/Widgets/ProductList/ProductListProductCard";
import { ellipsis, mergeWithCss, sharedBadgeStyle, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

productCardStyles.gridContainer = {
    css: css`
        display: grid;
        grid-template-columns: 114px minmax(0, 1fr) 219px;
        gap: 24px 12px;
        padding: 18px 12px;
        width: 100%;
        ${xScreen("lte", "sm")} {
            display: flex;
            flex-direction: column;
            gap: 20px;
            height: 100%;
        }
    `,
};
productCardStyles.leftColumnGridItem = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 5;
    `,
};

productCardStyles.infoGridItem = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 5;
        padding-right: 12px;
        ${xScreen("lte", "1100")} {
            padding-right: 0;
            grid-column: 2 / 4;
        }
    `,
};
productCardStyles.actionsGridItem = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 1 / 6;
        max-width: 219px;
        ${xScreen("lte", "1100")} {
            grid-row: 5 / 6;
        }
        ${xScreen("lte", "sm")} {
            margin-top: auto;
        }
    `,
};
productCardStyles.searchScoreDataGridItem = {
    css: css`
        grid-column: 1 / 4;
        grid-row: 6 / 7;
        min-height: 28px;
        &:empty {
            display: none;
        }
    `,
};
productCardStyles.productInformationStyles = {
    attributesGridItem: {
        width: 12,
        css: css`
            width: 100%;
            max-height: 88px;
            ${xScreen("lte", "sm")} {
                max-height: unset;
            }
        `,
    },
    attributes: {
        container: {
            css: css`
                flex-direction: row;
                column-gap: 12px;
                flex-wrap: wrap;
                height: 100%;
                width: 100%;
                & > div {
                    width: calc(50% - 6px);
                }
                ${xScreen("lte", "sm")} {
                    flex-direction: column;
                    & > div {
                        width: 100%;
                    }
                }
            `,
        },
    },
};

productCardStyles.productListProductImageStyles = {
    productImage: {
        linkWrappingImage: {
            css: css`
                width: 114px;
                height: 114px;
                ${xScreen("lte", "sm")} {
                    width: 100%;
                    height: 318px;
                    justify-content: center;
                }
            `,
        },
        img: {
            width: 318,
            height: 318,
            css: css`
                width: auto;
                max-width: 100%;
                max-height: 100%;
                height: auto;
            `,
        },
    },
    badgeText: {
        ...mergeWithCss(sharedBadgeStyle.badgeText, {
            css: css`
                ${ellipsis(1)}
            `,
        }),
    },
};
